import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { RegionGazUpdateDto } from '../../_dto/_regiongaz/RegionGazUpdateDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiUpdateRegionGaz = async (dto: RegionGazUpdateDto) => {
  const params: IApiParams = {
    url: '/regiongaz/updateRegion.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'PUT', dto);
};
